import { basicAxios } from "../../sevices/baseAxios";

export const addNewRole = async (data) => {
  const response = await basicAxios.post("/api/Account/AddRole", data);
  return response.data;
};
export const getUserRolesByUserId = async (id) => {
  const response = await basicAxios.get(`/api/Account/GetUserRoles?${id}`);
  return response.data;
};

export const getDeleteAllRoles = async (id) => {
  const response = await basicAxios.delete(`/api/Account/DeleteRoleById?id=${id}`);
  return response.data;
};

export const addUserRoles = async (data) => {
  const response = await basicAxios.post(`/api/Account/AddUserRoles`, data);
  return response.data;
};

export const getAllRoles = async (data) => {
  const response = await basicAxios.get(`/api/Account/GetRoles`);
  // console.log(response.data);
  return response.data;
};

export const getFilterAllRoles = async (data) => {
  const response = await basicAxios.post("/api/Account/FilterRoles", data);
  return response.data;
};
